import { Component, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { ToggleFavoriteAction } from '@records/records-search/records-details/state/form-view-state.actions';
import { Column } from '@miq/catalog';
import { ColumnFavoriteHandlerDirective } from '@records/controls/catalog-plotter/component-plotter/column-favorite-handler.directive';
import { FormViewState, FavoritesMap } from '@records/records-search/records-details/state';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'miq-pin-favorite',
  template: `
    <ng-container *ngIf="isPinShown">
      <div class="detailpage-pinscontainer__pin">
        <div tabindex="-1" mat-icon-button (click)="toggleFavorite()">
          <span
            [ngClass]="{
              'icon-unpin-icon': !isFavoriteColumn,
              'icon-pin-icon': isFavoriteColumn,
            }"
          >
          </span>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['./pin-favorite.component.scss'],
  standalone: false,
})
export class PinFavoriteComponent implements OnInit, OnChanges, OnDestroy {
  @Input() column: Column;
  public isPinShown = false;
  public isFavoriteColumn = false;

  favorites$: Observable<FavoritesMap>;
  private favoritesMap: FavoritesMap = {};
  constructor(
    @Optional() private store: Store,
    @Optional() private miqColumnFavoriteHandler?: ColumnFavoriteHandlerDirective
  ) {
    if (store) {
      this.favorites$ = store.select(FormViewState.favorites);
    }
  }
  ngOnChanges({ column }: SimpleChanges): void {
    // check if column input changed
    if (column && !column.firstChange) {
      // flag re-calculate due incoming column change by respecting current value OR if column required flag changed
      const hasChanged = column.previousValue.required != column.currentValue.required;
      if (hasChanged) {
        this.showPin();
        this.tickFavoriteState();
      }
    }
  }

  ngOnInit() {
    // show only if directive and Store are available in the dependency tree
    this.showPin();

    if (this.column != null && this.favorites$) {
      this.favorites$
        .pipe(
          untilDestroyed(this),
          tap(favorites => (this.favoritesMap = favorites))
        )
        // tick favorite state on every favorite$ state change
        .subscribe(() => this.tickFavoriteState());
    }
  }

  private tickFavoriteState(): void {
    this.isFavoriteColumn = this.favoritesMap[this.column.columnId];
  }

  toggleFavorite() {
    return !this.store
      ? null
      : this.store.dispatch(new ToggleFavoriteAction({ ...this.column, pinned: this.isFavoriteColumn }));
  }

  private showPin(): void {
    // show only if directive and Store are available in the dependency tree
    // if the field is required is pinned by default and not shown.
    this.isPinShown = this.store != null && this.miqColumnFavoriteHandler != null && !this.column.required;
  }

  ngOnDestroy(): void {
    // required by untilDestroyed
  }
}
